import {
	Component,
	ElementRef,
	EventEmitter,
	HostBinding,
	Input,
	OnChanges,
	Output,
	SimpleChanges,
	ViewChild,
	ViewEncapsulation,
} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';

const MaterialModules = [MatFormFieldModule, MatInputModule, MatIconModule];

@Component({
	standalone: true,
	selector: 'green-input-search',
	imports: [...MaterialModules, FormsModule, ReactiveFormsModule],
	template: `<mat-form-field class="no-padding flex-1 dark:!text-white">
		<input
			#searchInput
			matInput
			class="dark:!text-white"
			[placeholder]="label"
			type="search"
			[(ngModel)]="searchValue"
			(focus)="focusChange.emit(true)"
			(blur)="focusChange.emit(false)"
			(keydown.enter)="onEnter()"
			(ngModelChange)="inputChange.emit($event)" />
		<mat-icon
			matSuffix
			class="dark:!text-white"
			[color]="isLoading ? 'null' : 'primary'"
			(click)="!isLoading && searchEvent.emit(searchValue)">
			search
		</mat-icon>
	</mat-form-field>`,
	styleUrls: ['./input-search.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class InputSearchComponent implements OnChanges {
	@Input() isLoading = true;
	@Input() label = '';
	@Input() initialSearchValue = '';
	@Input() reset: boolean;

	@Output() searchEvent = new EventEmitter<string>();
	@Output() focusChange = new EventEmitter<boolean>();
	@Output() inputChange = new EventEmitter<string>();

	@ViewChild('searchInput') searchInput: ElementRef<HTMLInputElement>;

	@HostBinding('class') class =
		'flex justify-center items-start h-11 flex-1 max-w-sm box-border';

	searchValue = this.initialSearchValue;

	onEnter(): void {
		this.searchEvent.emit(this.searchValue);
		this.searchInput.nativeElement.blur();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.initialSearchValue) {
			this.searchValue = changes.initialSearchValue.currentValue;
		}
		if (changes.reset && !changes.reset.firstChange) {
			this.searchValue = '';
		}
	}
}
